import React from "react"
import { HistoricoFechamentosContextProvider } from "./context/HistoricoFechamentosContextProvider"
import { HistoricoFechamentos } from "./HistoricoFechamentos"

export function Index() {
    return (
        <HistoricoFechamentosContextProvider>
            <HistoricoFechamentos />
        </HistoricoFechamentosContextProvider>
    )
}
